import { render, staticRenderFns } from "./RequestFormEditor.vue?vue&type=template&id=543d23d7&scoped=true"
import script from "./RequestFormEditor.vue?vue&type=script&lang=js"
export * from "./RequestFormEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543d23d7",
  null
  
)

export default component.exports